import { SEOHead } from "@/components/SEOHead";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { LandingHero } from "@/components/landing/LandingHero";
import { PainSection } from "@/components/landing/PainSection";
import { SolutionSection } from "@/components/landing/SolutionSection";
import { ComparisonSection } from "@/components/landing/ComparisonSection";
import { DemoSection } from "@/components/landing/DemoSection";
import { SocialProofSection } from "@/components/landing/SocialProofSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { OnboardingSection } from "@/components/landing/OnboardingSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { FinalCTASection } from "@/components/landing/FinalCTASection";
import { LandingFooter } from "@/components/landing/LandingFooter";

export default function LandingPage() {
  return (
    <>
      <SEOHead 
        title="Gestão para Freelancers"
        description="Sistema completo de gestão para freelancers. Controle projetos, tempo, clientes e finanças em um só lugar. Teste grátis por 7 dias."
        canonical="/"
      />
      <div className="min-h-screen bg-background">
        <LandingHeader />
        <main>
          <LandingHero />
          <PainSection />
          <SolutionSection />
          <ComparisonSection />
          <DemoSection />
          <SocialProofSection />
          <FAQSection />
          <OnboardingSection />
          <PricingSection />
          <FinalCTASection />
        </main>
        <LandingFooter />
      </div>
    </>
  );
}
